/**
 * libraryFailure.js — story 167 (RN-11.1). The server's own message of a failed request, as
 * `Api_Functions.jsx` leaves it on the thrown object (`data.message || data.error`, or the plain body), or ''
 * when there is none — the caller then shows its generic text.
 */
export const failureMessageOf = (thrown) => (typeof thrown?.message === 'string' ? thrown.message.trim() : '')
